const WhatPeopleSay = {
	init: function (element) {
		element.querySelectorAll('li').forEach(li => {
			li.addEventListener('mouseenter', () => {
				const video = li.querySelector('video');
				if (video) {
					video.play();
				}
			});
			li.addEventListener('mouseleave', () => {
				const video = li.querySelector('video');
				if (video) {
					video.pause();
				}
			});
		});
	},
};

export default WhatPeopleSay;
